import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import DataTable from "react-data-table-component";
import { customTableStyles } from "../../assets/CustomTableStyles";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";

function MenuCategories() {
  const token = localStorage.getItem("token");

  const [triggerRerender, setTriggerRerender] = useState(false);

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    trigger,
    reset,
  } = useForm({
    defaultValues: { id: 0, name: "" },
  });

  const [categoriesData, setCategoriesData] = useState([]);

  const getCategoryList = async () => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await get("UserAuthentication/GetAllCategory", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setCategoriesData(response.navCategory);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    getCategoryList();
  }, [triggerRerender]);

  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <>
          <div className="d-flex gap-1">
            <button
              type="button"
              className="btn p-0"
              onClick={() => handleEditClick(row.id)}
            >
              <i className="fas fa-pencil"></i>
            </button>
            <button
              type="button"
              className="btn p-0"
              onClick={() => handleDeleteClick(row.id)}
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>
        </>
      ),
    },
  ];

  const handleEditClick = async (rowId) => {
    var formData = { id: rowId };
    try {
      const response = await post(
        `UserAuthentication/GetCategoryById`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const selectedCategory = response.navCategory;

      reset({ id: selectedCategory.id, name: selectedCategory.name });
    } catch (error) {
      console.error("Error fetching category:", error);
    }
  };

  const handleDeleteClick = async (rowId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this category?"
    );

    if (confirmDelete) {
      const formdata = { id: rowId };
      try {
        const response = await post(
          `UserAuthentication/DeleteNavCategory`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        getCategoryList();
      } catch (error) {
        console.error("Error deleting category:", error);
      }
    }
  };

  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await post(
        `UserAuthentication/AddUpdateNavCategory`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setTriggerRerender((prev) => !prev);
        reset({
          id: 0,
          name: "",
        });
      }
    } catch (error) {
      console.error("Error saving category:", error);
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Categories</h2>
      </div>

      <form className="row g-3" onSubmit={handleSubmit(saveData)}>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">
                    Category Name<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register(`name`, {
                      required: "This field is required.",
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                  />
                  {errors.name && (
                    <small className="text-danger">{errors.name.message}</small>
                  )}
                </div>
                <div className="col-12">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Save" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <DataTable
                columns={columns}
                data={categoriesData}
                pagination
                dense
                customStyles={customTableStyles}
                // onRowClicked={handleRowClick}
                highlightOnHover={true}
                // pointerOnHover={true}
              />
            </div>
          </div>
        </div>
      </form>
    </>
  );
}

export default MenuCategories;
